import {
  Badge,
  CardActions,
  CardContent,
  CardHeader,
  Typography,
} from "@mui/material";
import FelixCard from "../../../util/ui/felixCard";
import { Icon } from "@tabler/icons-react";

type Props = {
  alerta?: boolean;
  Icone: Icon;
  titulo: string;
  destaque: string | JSX.Element;
  conteudo: string | JSX.Element;
  rodape: string | JSX.Element;
};

export default function CardInformacaoAssinatura({
  alerta,
  Icone,
  titulo,
  destaque,
  conteudo,
  rodape,
}: Props) {
  return (
    <FelixCard>
      <CardHeader
        title={
          <Badge color="error" variant="dot" invisible={!alerta}>
            {titulo}
          </Badge>
        }
        avatar={<Icone size={16} />}
      />
      <CardContent sx={{ minHeight: 110, pt: 0 }}>
        <Typography variant="body2" color="text.secondary" component="div">
          {conteudo}
        </Typography>
        {/* Valor de destaque do card: tipo maior, sem competir com o título. */}
        <Typography
          variant="h4"
          color="text.primary"
          component="div"
          paddingTop={1}
        >
          {destaque}
        </Typography>
      </CardContent>
      <CardActions sx={{ px: 2, pt: 0 }}>
        <Typography variant="body2" color="text.secondary" component="div">
          {rodape}
        </Typography>
      </CardActions>
    </FelixCard>
  );
}
